import { render } from "./UserComponent.vue?vue&type=template&id=056d9e58"
import script from "./UserComponent.vue?vue&type=script&lang=js"
export * from "./UserComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thinley/dzg/feedback/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__